export default __webpack_public_path__ + "static/healthcare-change-02cae2b0f101401acaf10804ceb93826.png";